import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsAboutUsServicesProperties } from '../Models/CmsAboutUsProperties';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cms-aboutusservices',
  templateUrl: './cms-aboutusservices.component.html',
  styleUrls: ['./cms-aboutusservices.component.css']
})
export class CmsAboutUsServicesComponent {
  fSocialObj = new CmsAboutUsServicesProperties();
  constructor(private router: Router, private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }

  public progress: number;
  public message: string;
  
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("aboutUsServicesID") != undefined || localStorage.getItem("aboutUsServicesID") != null) {
        let id = Number(localStorage.getItem("aboutUsServicesID"));
        if (id != 0 || id != undefined) {
          this.userService.getAboutUsServicesById(id).subscribe((data) => {
            this.fSocialObj = data[0] as CmsAboutUsServicesProperties;
            localStorage.removeItem("aboutUsServicesID");
          });
        }
      }
    }
    catch (e) {
      //console.log(e);
    }
  }
  onSubmit() {
    if (this.fSocialObj.serviceID == 0 || this.fSocialObj.serviceID == null) {
      this.userService.createAboutUsServices(this.fSocialObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    } else {
      this.userService.updateAboutUsServices(this.fSocialObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }

    ////console.log(this.imagePath);
  }
  cancelCLICK() {
    this.router.navigate(["/cms"]);
  }
}
